import React, { useState } from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

const FilterTags = ({ onChange, selected, setSelected }) => {
//   const [selected, setSelected] = useState(['image', 'video']); // Both selected by default

  const handleChange = (event, newSelected) => {
    // Prevent deselecting all
    if (newSelected.length === 0) return;

    setSelected(newSelected);
    onChange && onChange(newSelected);
  };

  return (
    <ToggleButtonGroup
      value={selected}
      onChange={handleChange}
      aria-label="media type filter"
    >
      <ToggleButton value="PHOTO" aria-label="image">
        Image
      </ToggleButton>
      <ToggleButton value="VIDEO" aria-label="video">
        Video
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default FilterTags;
